import React, { useContext, useEffect, useState } from 'react';
import { RadioGroup, Input } from '@progress/kendo-react-inputs';
import ItemPreview from '../../ItemPreview';
import ListEditor from '../../ListEditor';
import { LocalizationContext } from '../../../contexts';
import PublishSwitch from '../publishSwitch';
import './index.scss';
import '../forms.scss';

export default function SwimlineContent({ data, settingsData = {}, onUpdate, validator, ...rest }) {
  const emptyItem = { title: "", id: "", isPublish: false };
  const [compData, setCompData] = useState({});
  const [localization] = useContext(LocalizationContext);
  const { labels } = localization;

  if (validator) {
    validator.current = () => {
      return true;
    };
  }

  useEffect(() => {
    let defaultData = { items: [{ ...emptyItem }], title: "" };
    if (settingsData.line_location) {
      defaultData.location = "top";
    }
    const startCompData = { ...defaultData, ...JSON.parse(JSON.stringify(data ? data : {})) };
    if (startCompData.items.length === 0) {
      startCompData.items = [{ ...emptyItem }];
    }
    setCompData(startCompData);
  }, [data]);

  const updateItem = (i, newData, key) => {
    let newCompData;
    if (i !== null) {
      newCompData = { ...compData };
      if (key) {
        newCompData.items[i][key] = newData;
      }
      else {
        newCompData.items[i] = { ...newCompData.items[i], ...newData };
      }
      newCompData.items[i].isPublish = newCompData.items[i].isPublish && !!(newCompData.items[i].title && newCompData.items[i].id);
    } else {
      newCompData = { ...compData, ...newData };
    }
    setCompData(newCompData);
    onUpdate(newCompData);
  };

  const title = (settings) => {
    return settingsData.title ? eval("`" + settingsData.title + "`") : false;
  };

  const isEmptyItem = () => {
    return JSON.stringify(compData) === JSON.stringify(emptyItem.current)
  }

  const showRequired = (requiredField) => {
    return (!isEmptyItem() && !requiredField)
  }

  const startElement = <>
    <div className="form-field">
      <label className="form-field__label mandatory">{labels.pagesManagement.swimlineContent.add_title}</label>
      <Input name={'swimlineTitle'} value={compData.title} onChange={({ value }) => updateItem(null, { title: value })}></Input>
      {showRequired(compData.title) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
    </div>
    {settingsData.line_location && <div className="form-field">
      <label className="form-field__label inline">{labels.pagesManagement.swimlineContent.line_location}</label>
      <RadioGroup data={[
        { label: labels.pagesManagement.swimlineContent.top, value: 'top' },
        { label: labels.pagesManagement.swimlineContent.bottom, value: 'bottom' }
      ]}
        layout='horizontal'
        value={compData.location}
        onChange={({ value }) => {
          updateItem(null, { location: value });
        }}
      />
    </div>}
  </>;

  const itemTitle = (item, settings) => {
    return `${labels.pagesManagement.swimlineContent.item} ${settings.index + 1}: ${item.title} (${!(item.title && item.id) ? labels.pagesManagement.forms.publish_not_ready : item.isPublish ? labels.pagesManagement.forms.is_publish : labels.pagesManagement.forms.publish_ready})`;
  };

  const itemContent = (item, settings) => {
    return <>
      <div className="form-field">
        <label className="form-field__label mandatory">{labels.pagesManagement.swimlineContent.add_item_title}</label>
        <Input name={'title'} value={item.title} onChange={({ value }) => updateItem(settings.index, value, 'title')}></Input>
        {showRequired(item.title) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
      </div>
      <div className="form-field">
        <label className="form-field__label mandatory">{labels.pagesManagement.swimlineContent.add_item_id}</label>
        <Input name={'id'} value={item.id} onChange={({ value }) => updateItem(settings.index, value, 'id')}></Input>
        <div className="form-field__item">{item?.id && <ItemPreview itemID={item.id} onItemLoad={(itemData) => { if (itemData && itemData.title && !item.title) updateItem(settings.index, itemData.title, 'title') }} />}</div>
        {showRequired(item.id) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
      </div>
      <PublishSwitch isPublish={item?.isPublish} canPublish={item.title && item.id}
        updateItem={(event) => updateItem(settings.index, { isPublish: event.target.value })} />
    </>;
  };

  return <ListEditor
    isSortable={true}
    canRemove={true}
    canAdd={true}
    removeContentOnClose={false}
    maxSize={settingsData.maxSize || 10}
    minSize={settingsData.minSize || 0}
    className="swimlineContent-listEditor"
    addNewItemBtnText={labels.pagesManagement.swimlineContent.addNewItemBtnText}
    title={settingsData.title && title}
    startElement={startElement}
    emptyItem={emptyItem}
    itemTitle={itemTitle}
    itemContent={itemContent}
    list={[...(compData.items || [])]}
    onListUpdate={(newList) => { updateItem(null, { items: newList }) }}
  />;
};